module.exports = __webpack_public_path__ + "img/下载.8fe69594.png";